module.exports = __webpack_public_path__ + "media/icons/arrow-right-square@2x-5741e455.png";